<template>
  <header>
    <b-navbar
      v-if="isDark"
      toggleable="lg"
      type="dark"
      variant="dark"
      class="p-3"
    >
      <b-navbar-brand href="/">Collectio</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="/">ホーム</b-nav-item>
          <b-nav-item href="/book">みんなの本</b-nav-item>
          <b-nav-item href="/question">みんなの問い</b-nav-item>
          <b-nav-item href="/bookpost">本を登録する</b-nav-item>
          <b-nav-item href="/findfriends">友達を見つける</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <div v-if="$store.getters.isSignedIn">
            <b-button
              variant="outline-success"
              class="mx-3"
              v-on:click="goToMyPage"
            >
              マイページ
            </b-button>
            <b-button variant="outline-success" @click="signOut">
              ログアウト
            </b-button>
          </div>
          <div v-else>
            <b-button variant="outline-success" @click="signIn">
              ログイン
            </b-button>
          </div>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-navbar v-else toggleable="lg" type="light" variant="light" class="p-3">
      <b-navbar-brand href="/">Collectio</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="/">ホーム</b-nav-item>
          <b-nav-item href="/book">みんなの本</b-nav-item>
          <b-nav-item href="/question">みんなの問い</b-nav-item>
          <b-nav-item href="/bookpost">本を登録する</b-nav-item>
          <b-nav-item href="/findfriends">友達を見つける</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <div v-if="$store.getters.isSignedIn">
            <b-button
              variant="outline-success"
              class="mx-3"
              v-on:click="goToMyPage"
            >
              マイページ
            </b-button>
            <b-button variant="outline-success" @click="signOut">
              ログアウト
            </b-button>
          </div>
          <div v-else>
            <b-button variant="outline-success" @click="signIn">
              ログイン
            </b-button>
          </div>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>
// import firebase from "firebase";
import { signIn, signOut } from "@/firebase";

export default {
  data: function() {
    return {
      isDark: this.$store.getters.user.isDark
    };
  },
  methods: {
    signIn() {
      if (this.$store.getters.user.isDark) {
        document.location.reload();
      }
      signIn();
    },
    signOut() {
      this.$store.commit("RESET_VUEX_STATE"); //セッションストレージを初期化
      this.$router.push({ path: "/" });
      signOut();
    },
    goToMyPage() {
      this.$router.push("/user/" + this.$store.getters.user.uid);
      location.reload();
    }
  },
  created() {}
};
</script>

<style lang="scss">
.title-font {
  font-family: "Times New Roman", Times, serif;
}
</style>
